import { useTranslation } from "react-i18next";
import CalendarIcon from "../../../icons/calendarIcon";
import CheckSquareIcon from "../../../icons/checkSquareIcon";
import DollarCircleIcon from "../../../icons/dollarCiircleIcon";
import FileIcon from "../../../icons/fileIcon";
import HeadPhoneIcon from "../../../icons/headphoneIcon";
import LocationIcon from "../../../icons/locationIcon";
import NetworkIcon from "../../../icons/networkIcon";
import ScaleIcon from "../../../icons/scaleIcon";
import ShieldIcon from "../../../icons/shieldIcon";
import StampIcon from "../../../icons/stampIcon";
import TrackingIcon from "../../../icons/trackingIcon";
import TruckIcon from "../../../icons/truckIcon";
import LandTransportationCard from "./landTransportationCard";

const LandTransportation = () => {
  const { t } = useTranslation();
  return (
    <main className="py-20 ">
      <div className="w-11/12 mx-auto space-y-10">
        <section>
          <h1 className=" font-semibold text-[32px] text-center pb-10 ">
            {t("landTransportation")}
          </h1>
          <h2 className="text-mainRed text-[20px] my-4 font-bold">
            {t("landShippingAcrossMiddleEast")}
          </h2>
          <p className=" text-[18px]">{t("weOfferFlexibleAndReliable")}</p>
        </section>
        <section className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/landTransport1.jpg"
            alt="land transportation 1"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/landTransport2.jpg"
            alt="land transportation 2"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/landTransport3.jpg"
            alt="land transportation 3"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/landTransport4.jpg"
            alt="land transportation 4"
          />
        </section>
        <h3 className=" font-semibold text-[32px] text-center py-10 ">
          {t("ourLandTransportation")}
        </h3>
        <section>
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("1LandTransportation")}
          </h3>
          <div className="flex gap-5">
            <LandTransportationCard
              icon={<TruckIcon fill={"#0051FF"} />}
              header={t("fleetAndEquipment")}
              description={t("modernFleetOfTrucks")}
            />
            <LandTransportationCard
              icon={<CalendarIcon />}
              header={t("planningAndScheduling")}
              description={t("advancedSchedulingSystem")}
            />
            <LandTransportationCard
              icon={<TrackingIcon />}
              header={t("technologyAndTracking")}
              description={t("realTimeGpsTracking")}
            />
          </div>

          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("contractualTerms")}
          </h3>
          <div className="flex gap-5">
            <LandTransportationCard
              icon={<FileIcon />}
              header={t("serviceAgreement")}
              description={t("comprehensiveServiceAgreements")}
            />
            <LandTransportationCard
              icon={<ShieldIcon />}
              header={t("insuranceAndCompensation")}
              description={t("fullCoverageInsurance")}
            />

            <LandTransportationCard
              icon={<DollarCircleIcon />}
              header={t("flexibilityAndPricing")}
              description={t("transparentModels")}
            />
          </div>

          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("globalService")}
          </h3>
          <div className="flex gap-5">
            <LandTransportationCard
              icon={<NetworkIcon fill={"#0051FF"} />}
              header={t("expansionStrategy")}
              description={t("networkExpansion")}
            />

            <LandTransportationCard
              icon={<CheckSquareIcon />}
              header={t("complianceWithStandards")}
              description={t("adherenceToRegulations")}
            />
          </div>

          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("transportFromPorts")}
          </h3>
          <div className="flex gap-5">
            <LandTransportationCard
              icon={<ScaleIcon width={40} height={40} />}
              header={t("LogisticsCoordination")}
              description={t("seamlessCoordination")}
            />

            <LandTransportationCard
              icon={<StampIcon />}
              header={t("unloadingAndCustoms")}
              description={t("expertHandling")}
            />
          </div>
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("fastDelivery")}
          </h3>
          <div className="flex gap-5">
            <LandTransportationCard
              icon={<LocationIcon className="size-10" />}
              header={t("dynamicRoute")}
              description={t("optimizedRoute")}
            />

            <LandTransportationCard
              icon={<HeadPhoneIcon />}
              header={t("supportAndNotification")}
              description={t("roundTheClockCustomerSupport")}
            />
          </div>
        </section>
      </div>
    </main>
  );
};

export default LandTransportation;
